var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content_top_wrap"},[_c('div',{staticClass:"content_top"},[_c('div',{staticClass:"tab_wrap"},[_c('PageTabMenu',{attrs:{"currentRoute":_vm.$route.fullPath}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }